import fgInput from './components/Inputs/formGroupInput.vue'
import DropDown from './components/Dropdown.vue'
import Card from './components/Cards/Card.vue'
import Button from './components/Button.vue'
import {Input, InputNumber, Tabs, TabPane, Select, Option} from 'element-ui'
import {Collapse, CollapseItem, Table, TableColumn, Dialog} from 'element-ui'
import ElButton from 'element-ui/lib/button'
import AccountProfile from './components/Setup/AccountProfile.vue'
// import ProductsSetup from './components/Setup/ProductsSetup.vue'
import Radio from './components/Inputs/Radio.vue'
import SpiffsLeadsSetup from './components/Setup/SpiffsLeadsSetup.vue'
import AffiliateCompaniesSetup from './components/Setup/AffiliateCompaniesSetup.vue'
import Switch from './components/Switch.vue'
import AffiliateModal from './components/Modals/AffiliateModal.vue'
import AffiliateInvitationModal from './components/Modals/AffiliateInvitationModal.vue'
import UsersSetup from './components/Setup/UsersSetup.vue'
import EditUser from './components/Setup/EditUser.vue'
import EditAffiliateCompany from './components/Setup/EditAffiliateCompany.vue'
import Checkbox from './components/Inputs/Checkbox.vue'
import AffiliatesMiniCard from './components/Cards/AffiliatesMiniCard.vue'
import PayoutsMiniCard from './components/Cards/PayoutsMiniCard.vue'
import LeadsReceivedMiniCard from './components/Cards/LeadsReceivedMiniCard.vue'
import LeadsClosedMiniCard from './components/Cards/LeadsClosedMiniCard.vue'
import AffiliatesCard from './components/Cards/AffiliatesCard.vue'
import LeadsGraphSingleViewCard from './components/Cards/LeadsGraphSingleViewCard.vue'
import LeadsGraphMultiViewCard from  './components/Cards/LeadsGraphMultiViewCard.vue'
import CloseRateMultiViewCard from './components/Cards/CloseRateMultiViewCard.vue'
import PieChart from './components/Cards/LeadsPieChartMultiViewCard.vue'
import AffiliatesTable from './components/Tables/AffiliatesTable.vue'
import ChartCard from './components/Cards/ChartCard.vue'
import PayoutModal from './components/Modals/PayoutModal.vue'
import LeadModal from './components/Modals/LeadModal.vue'
import LeadStatusInput from './components/Inputs/LeadStatusInput.vue'
import AffiliateCompanyModal from './components/Modals/AffiliateCompanyModal.vue'
import WelcomeCard from './components/Cards/WelcomeCard.vue'
import PeriodSelector from './components/Inputs/PeriodSelector.vue'
import CompanySelector from './components/Inputs/CompanySelector.vue'
import PayoutsPendingMiniCard from './components/Cards/PayoutsPendingMiniCard.vue'
import PayoutsToSubmitMiniCard from './components/Cards/PayoutsToSubmitMiniCard.vue'
import PayoutsPaidMiniCard from './components/Cards/PayoutsPaidMiniCard.vue'
import PayoutsSubmittedMiniCard from './components/Cards/PayoutsSubmittedMiniCard.vue'
import RowSelectionCheckbox from './components/Inputs/RowSelectionCheckbox.vue'
import PayoutsConfirmationModal from './components/Modals/PayoutsConfirmationModal.vue'
import PayoutsPieChartMultiViewCard from './components/Cards/PayoutsPieChartMultiViewCard.vue'
import PayoutsGraphMultiViewCard from './components/Cards/PayoutsGraphMultiViewCard.vue'
import PayoutsGraphSingleViewCard from './components/Cards/PayoutsGraphSingleViewCard.vue'
import UserModal from './components/Modals/UserModal.vue'
// ------------------- //
import AffiliateAccountsTable from './components/Tables/AffiliateAccountsTable.vue'
import AffiliateAccountsCard from './components/Cards/AffiliateAccountsCard.vue'
import IncentifyerAccountsTable from './components/Tables/IncentifyerAccountsTable.vue'
import IncentifyerAccountsCard from './components/Cards/IncentifyerAccountsCard.vue'
import UsersTable from './components/Tables/UsersTable.vue'
import UsersCard from './components/Cards/UsersCard.vue'
import AffiliateCompaniesTable from './components/Tables/AffiliateCompaniesTable.vue'
import AffiliateCompaniesCard from './components/Cards/AffiliateCompaniesCard.vue'
import PaymentCardsTable from './components/Tables/PaymentCardsTable.vue'
import PaymentCardsCard from './components/Cards/PaymentCardsCard.vue'
import PayoutsTable from './components/Tables/PayoutsTable.vue'
import PayoutsCard from './components/Cards/PayoutsCard.vue'
import LeadsTable from './components/Tables/LeadsTable.vue'
import LeadsCard from './components/Cards/LeadsCard.vue'
import PaymentCardModal from './components/Modals/PaymentCardModal.vue'
import PaymentCardBalanceModal from './components/Modals/PaymentCardBalanceModal.vue'
import IncentifyerAccountModal from './components/Modals/IncentifyerAccountModal.vue'


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    Vue.component('card', Card)
    Vue.component(Button.name, Button)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
    Vue.component(AccountProfile.name, AccountProfile)
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
    Vue.component(Select.name, Select)
    Vue.component(Option.name, Option)
    // Vue.component(ProductsSetup.name, ProductsSetup)
    Vue.component(SpiffsLeadsSetup.name, SpiffsLeadsSetup)
    Vue.component(Collapse.name, Collapse)
    Vue.component(CollapseItem.name, CollapseItem)
    Vue.component(Radio.name, Radio)
    Vue.component(AffiliateCompaniesSetup.name, AffiliateCompaniesSetup)
    Vue.component(ElButton.name, Button)
    Vue.component(Table.name, Table)
    Vue.component(TableColumn.name, TableColumn)
    Vue.component(Switch.name, Switch)
    Vue.component(AffiliateModal.name, AffiliateModal)
    Vue.component(AffiliateInvitationModal.name, AffiliateInvitationModal)
    Vue.component(Dialog.name, Dialog)
    Vue.component(UsersSetup.name, UsersSetup)
    Vue.component(EditUser.name, EditUser)
    Vue.component(EditAffiliateCompany.name, EditAffiliateCompany)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(AffiliatesMiniCard.name, AffiliatesMiniCard)
    Vue.component(PayoutsMiniCard.name, PayoutsMiniCard)
    Vue.component(LeadsReceivedMiniCard.name, LeadsReceivedMiniCard)
    Vue.component(LeadsClosedMiniCard.name, LeadsClosedMiniCard)
    Vue.component(AffiliatesCard.name, AffiliatesCard)
    Vue.component(LeadsCard.name, LeadsCard)
    Vue.component(LeadsGraphSingleViewCard.name, LeadsGraphSingleViewCard)
    Vue.component(LeadsGraphMultiViewCard.name, LeadsGraphMultiViewCard)
    Vue.component(PieChart.name, PieChart)
    Vue.component(CloseRateMultiViewCard.name, CloseRateMultiViewCard)
    Vue.component(AffiliatesTable.name, AffiliatesTable)
    Vue.component(ChartCard.name, ChartCard)
    Vue.component(PayoutModal.name, PayoutModal)
    Vue.component(LeadModal.name, LeadModal)
    Vue.component(LeadStatusInput.name, LeadStatusInput)
    Vue.component(AffiliateCompanyModal.name, AffiliateCompanyModal)
    Vue.component(WelcomeCard.name, WelcomeCard)
    Vue.component(PeriodSelector.name, PeriodSelector)
    Vue.component(CompanySelector.name, CompanySelector)
    Vue.component(PayoutsPendingMiniCard.name, PayoutsPendingMiniCard)
    Vue.component(PayoutsToSubmitMiniCard.name, PayoutsToSubmitMiniCard)
    Vue.component(PayoutsPaidMiniCard.name, PayoutsPaidMiniCard)
    Vue.component(PayoutsSubmittedMiniCard.name, PayoutsSubmittedMiniCard)
    Vue.component(RowSelectionCheckbox.name, RowSelectionCheckbox)
    Vue.component(PayoutsConfirmationModal.name, PayoutsConfirmationModal)
    Vue.component(PayoutsPieChartMultiViewCard.name, PayoutsPieChartMultiViewCard)
    Vue.component(PayoutsGraphMultiViewCard.name, PayoutsGraphMultiViewCard)
    Vue.component(PayoutsGraphSingleViewCard.name, PayoutsGraphSingleViewCard)
    Vue.component(UserModal.name, UserModal)
    // ------------------- //
    Vue.component(AffiliateAccountsTable.name, AffiliateAccountsTable)
    Vue.component(AffiliateAccountsCard.name, AffiliateAccountsCard)
    Vue.component(IncentifyerAccountsTable.name, IncentifyerAccountsTable)
    Vue.component(IncentifyerAccountsCard.name, IncentifyerAccountsCard)
    Vue.component(UsersTable.name, UsersTable)
    Vue.component(UsersCard.name, UsersCard)
    Vue.component(AffiliateCompaniesTable.name, AffiliateCompaniesTable)
    Vue.component(AffiliateCompaniesCard.name, AffiliateCompaniesCard)
    Vue.component(PaymentCardsTable.name, PaymentCardsTable)
    Vue.component(PaymentCardsCard.name, PaymentCardsCard)
    Vue.component(PayoutsTable.name, PayoutsTable)
    Vue.component(PayoutsCard.name, PayoutsCard)
    Vue.component(LeadsTable.name, LeadsTable)
    Vue.component(LeadsCard.name, LeadsCard)
    Vue.component(PaymentCardModal.name, PaymentCardModal)
    Vue.component(PaymentCardBalanceModal.name, PaymentCardBalanceModal)
    Vue.component(IncentifyerAccountModal.name, IncentifyerAccountModal)
  }
}

export default GlobalComponents
